import { http } from "../../utils/config";

const giftExchangeAPI = {
  
    getDashboard: (params = {}) => {
        const {
            mcouponBranchId = '',
            type = '',
            status = '',
            selectedDates = '',
        } = params;

        let start_date = '';
        let end_date = '';

        if (selectedDates && selectedDates.length > 0) {
            start_date = selectedDates[0];
            end_date = selectedDates[1];
        }

        const queryParams = new URLSearchParams({
            ...(mcouponBranchId && { mcouponBranchId }),
            ...(type && { type }),
            ...(status && { status }),
            ...(start_date && { start_date }),
            ...(end_date && { end_date })
        });

        return http.get(`/api/v1/serviceconnect/gift-exchange-for-customers/cms/histories/dashboard?${queryParams}`);
    },

    inStock: (id, data) => http.put(`/api/v1/serviceconnect/gift-exchanges/${id}/in-stock`, data),

    // Cập nhật địa chỉ nhận quà (SHOP) — chỉ khi quà chưa gửi
    updateGiftAddress: (data) =>
        http.post(`/api/v1/serviceconnect/gift-exchange-for-customers/update-address`, data),
};

// Error handling wrapper
export const withErrorHandling = (apiFunction) => {
  return async (...args) => {
    try {
      const response = await apiFunction(...args);
      return response;
    } catch (error) {
      console.error('API Error:', error);

      // Handle different types of errors
      if (error.response) {
        // Server responded with error status
        const { status, data } = error.response;
        switch (status) {
          case 400:
            throw new Error(data.message || 'Dữ liệu không hợp lệ');
          case 401:
            throw new Error('Bạn cần đăng nhập để thực hiện thao tác này');
          case 403:
            throw new Error('Bạn không có quyền thực hiện thao tác này');
          case 404:
            throw new Error('Không tìm thấy khách hàng');
          case 422:
            throw new Error(data.message || 'Dữ liệu không hợp lệ');
          case 500:
            throw new Error(data.message || "Lỗi server, vui lòng thử lại sau");
          default:
            throw new Error(data.message || 'Đã có lỗi xảy ra');
        }
      } else if (error.request) {
        // Network error
        throw new Error('Không thể kết nối đến server');
      } else {
        // Other error
        throw new Error(error.message || 'Đã có lỗi xảy ra');
      }
    }
  };
};

// Wrapped API functions with error handling
export const giftExchangeAPIWithErrorHandling = {
  getDashboard: withErrorHandling(giftExchangeAPI.getDashboard),
  inStock: withErrorHandling(giftExchangeAPI.inStock),
  updateGiftAddress: withErrorHandling(giftExchangeAPI.updateGiftAddress),
};

export default giftExchangeAPI;